import {action} from 'mobx';

import apiCollectionGetContentStore from '../collection/apiCollectionGetContentStore';
import ApiBaseStore from '../common/apiBaseStore';
import {STATE_PENDING, STATE_FULFILLED, STATE_REJECTED} from '../../../constants/asyncConstants';
import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import serverApi from '../../../utils/serverApi';

/**
 * ApiContentUnPublishManyStore
 */
class ApiContentUnPublishManyStore extends ApiBaseStore {
  /**
   * Makes the api request.
   *
   * @param {Array<number|string>} contentIds
   * @param {number|string} collectionId
   */
  @action makeRequest(contentIds, collectionId) {
    if (!contentIds) {
      this.state = STATE_REJECTED;
      this.error = new Error('Invalid content id given to contentUnPublishMany.');
      return;
    } else if (!collectionId) {
      this.state = STATE_REJECTED;
      this.error = new Error('Invalid collection id given to contentUnPublishMany.');
      return;
    }

    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.contentUnPublishMany(
      contentIds,
      collectionId
    ).then(
      action('contentUnPublishManySuccess', () => {
        this.error = null;
        this.state = STATE_FULFILLED;
        this.data = true;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;

        // Clear the collection cache.
        apiCollectionGetContentStore.refresh(collectionId, true);
      }),
      action('contentUnPublishManyError', (error) => {
        this.error = error;
        this.state = STATE_REJECTED;
        this.data = false;
      })
    );
  }
}

export default new ApiContentUnPublishManyStore();
